"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sweetAlertSuccessShow = exports.sweetAlertErrorShow = exports.sweetAlertUpdate = exports.sweetAlertShow = void 0;
const react_1 = __importDefault(require("react"));
const constants_1 = require("../base/constants");
const constants_2 = require("../constants");
const translate_1 = require("../../../components/translate");
const sweetAlertShow = (config) => ({
    type: constants_2.SWEET_ALERT_SHOW,
    payload: Object.assign({ show: true, type: constants_1.TYPE_DEFAULT }, config),
});
exports.sweetAlertShow = sweetAlertShow;
const sweetAlertUpdate = (config) => ({
    type: constants_2.SWEET_ALERT_UPDATE,
    payload: Object.assign({ show: true, type: constants_1.TYPE_DEFAULT }, config),
});
exports.sweetAlertUpdate = sweetAlertUpdate;
const sweetAlertErrorShow = (config = {}) => {
    const title = config.title || translate_1.translate.translate('react_components_sweetAlert', 'Error');
    return ({
        type: constants_2.SWEET_ALERT_SHOW,
        payload: Object.assign({ show: true, title, type: constants_1.TYPE_ERROR, cancelBtnIsVisible: false, confirmBtnFocus: false, btnSize: null, confirmBtnText: (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "d-flex align-items-center" },
                    translate_1.translate.translate('react_components_sweetAlert', 'Come back'),
                    react_1.default.createElement("i", { className: "fal fa-long-arrow-right" })))) }, config),
    });
};
exports.sweetAlertErrorShow = sweetAlertErrorShow;
const sweetAlertSuccessShow = (config = {}) => ({
    type: constants_2.SWEET_ALERT_SHOW,
    payload: Object.assign({ show: true, title: translate_1.translate.translate('react_components_sweetAlert', 'Excellent!'), type: constants_1.TYPE_ERROR, cancelBtnIsVisible: false, confirmBtnFocus: false, btnSize: null, confirmBtnText: (react_1.default.createElement(react_1.default.Fragment, null,
            translate_1.translate.translate('react_components_sweetAlert', 'Come back'),
            react_1.default.createElement("i", { className: "fal fa-long-arrow-right" }))), image: '/images/icons/success.png' }, config),
});
exports.sweetAlertSuccessShow = sweetAlertSuccessShow;
